/**
* @Author: 858834013@qq.com
* @Name: headers
* @Date: 2022-05-30
* @Desc:
*/
<template>
  <div class="headers">
    <div class="headersLeft wow fadeInLeft" data-wow-delay="1s">
      <div class="list">
        <div class="items" v-show="menusList.indexOf('HOME_PAGE')!='-1'" @click="toother('/newhome','1')">
          <span >首页</span>
        </div>
        <div class="items" v-show="menusList.indexOf('MONITOR_CENTER')!='-1'" @click="toother('/stationList','2')">
          <span >监测中心</span>
        </div>
        <div class="items" v-show="menusList.indexOf('ALARM_CENTER')!='-1'" @click="toother('/electricWarn','3')">
          <span >异常中心</span>
        </div>
        <div class="items" v-show="menusList.indexOf('DEVICE_CENTER')!='-1'" @click="toother('/deviceManger','4')">
          <span >设备中心</span>
        </div>
<!--        <div class="items" v-show="menusList.indexOf('DEVICE_CENTER')!='-1'" @click="toother('/godManger','6')">-->
<!--          <span >打标管理</span>-->
<!--        </div>-->
      </div>
    </div>
    <div class="headerTitle wow flipInX" data-wow-delay="1s">
      <span>万户安智慧用电管理平台</span>
    </div>
    <div class="headersRight wow fadeInRight" data-wow-delay="1s">
      <dayTime></dayTime>
      <img class="headerLine" src="../assets/home/icon_line.png" alt="">
      <div class="message">
        <img src="../assets/home/icon_user.png" alt="">
        <p @click="showPersonCenter()">{{ userName }}</p>
      </div>
      <img class="headerLine" src="../assets/home/icon_line.png" alt="">
      <div class="message">
        <p v-show="menusList.indexOf('CONFIG_CENTER')!='-1'" @click="toother('/userManage','5')">配置管理</p>
      </div>
      <img class="headerLine" src="../assets/home/icon_line.png" alt="">
      <div class="logout cur" @click="logout">
        <img src="../assets/home/icon_logout.png" alt="">
        <span @click="exitLogin()">退出</span>
      </div>
    </div>
  </div>
</template>

<script>
import dayTime from "@/components/dayTime";
import Bus from "../utils/bus.js";
import Vue from "vue";
export default {
  name: "headers",
  components: {dayTime},
  props: {
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      a: 0,
      userName:"",
      menusList:"",
    }
  },
  mounted() {
    new this.$wow.WOW().init()
    this.menusList=JSON.parse(localStorage.getItem("menusList"))
    this.userName = localStorage.getItem("userName");
  },
  watch: {},
  methods: {
    exitLogin() {
      this.$router.push("/newlogin");
    },
    showPersonCenter() {
      this.$router.push("/personalCenter");
    },

    logout() {
      var that = this
      localStorage.removeItem('token')
      this.$router.push({path: '/newlogin'});
    },
    toother(router,active){
      let rout=''
      if(active=='1'){
        if (sessionStorage.getItem("url") == 2)
        {
          rout='/singlehome'
        }else{
          rout='/newhome'
        }
      }else{
        rout=router
      }

      sessionStorage.setItem("active",active)
      this.$router.push(rout);

    },
  }
}
</script>

<style lang="scss" scoped>
.headers {
  width: 100%;
  height: 87px;
  background: url("../assets/home/titlebg.png") top center no-repeat;
  background-size: 1937px 87px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
  position: relative;
  z-index: 10;


  .headersLeft {
    width: 30%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;

    .list {
      margin-left: 30px;
    }

    .items {
      background: url("../assets/home/headerTabbg.png") no-repeat;
      background-size:100% 100%;
      width: 100px;
      height: 38px;
      opacity: 0.9;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      margin-right: 30px;
      cursor: pointer;

      span {
        font-size: 18px;
        font-family: PingFang;
        font-weight: 500;
        color: #34DCFC;
      }

    }

    .items:hover {
      opacity: 1;
    }
  }

  .headerTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;

    span {
      font-size: 30px;
      font-family: PingFang;
      font-weight: bold;
      color: #FFFFFF;

      background: linear-gradient(0deg, #0344FF 0%, #05DCF8 80.126953125%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .headersRight {
    width: calc(30% - 30px);
    padding-right: 30px;
    height: 24px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;
    color: #fff;
    font-size: 16px;

    .message {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      cursor: pointer;

      img {
        width: 15px;
        margin-right: 10px;
      }

      p {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 400;
        color: #34DCFC;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;

        span {
          margin-left: 0;
          margin-right: 0;
          color: rgba(52, 220, 252, 1);
          font-style: normal;
          font-size: 12px;
          display: inline-block;
          transform: scale(0.80);
          -ms-transform: scale(0.80); /* IE 9 */
          -webkit-transform: scale(0.80); /* Safari 和 Chrome */
          -moz-transform: scale(0.80); /* Firefox */
          -o-transform: scale(0.80); /* Opera */
        }
      }
    }

    .userhead {
      width: 23px;
      height: 22px;
    }

    .suoxiao {
      width: 18px;
      height: 18px;
    }

    span {
      font-size: 16px;
      font-family: PingFang;
      font-weight: 500;
      color: #01AAFF;
      margin-left: 10px;
      margin-right: 14px;
    }

    .logout {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;

      img {
        width: 15px;
      }

      span {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 400;
        color: #34DCFC;
        margin-left: 10px;
      }
    }
  }
}

.userInfos {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
}

.cBody {
  width: 100px;
  background: #011857;
  border: 1px solid #0a60c2;
  margin-top: -10px;

  .cItem {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;
    color: #fff;
    font-size: 14px;
    margin: 0 auto;
  }

  .cItem:hover {
    background: rgba(#00CCFF, 0.3);
  }
}

.headerLine {
  margin-left: 15px;
  margin-right: 15px;
  width: 1px;
}

.list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;

  .items {

  }
}
</style>
